import {ILocation } from 'interfaces';
import {axiosAPI} from './API';

// Singleton for interacting with locations
class _LocationsService {   

    public locationsPageCache: ILocation[] = []; 

    public getLocations = (numbers: string[]): Promise<ILocation[]> => {
        const p = axiosAPI.post<ILocation[]>('/locations/get', {locationNumbers: numbers})
            .then((resp) => {
                return resp.data;
            });

        p.catch((err) => {
            console.error('Error getting locations: ', err);
        });

        return p;
    }

    public searchLocations = (query: string): Promise<ILocation[]> => {
        if (query == "") {
            return Promise.resolve([])
        }
        const queryEncoded = encodeURIComponent(query)

        const p = axiosAPI.get<ILocation[]>(`/locations/search?query=${queryEncoded}`)
            .then((resp) => {
                return resp.data;
            });

        p.catch((err) => {
            console.error('Error searching locations: ', err);
        });

        return p;

    }

}

export const LocationsService = new _LocationsService();
